import SSOButtons from './SSOButtons'

export default function Login() {
  return <SSOButtons />
}
